import { render } from "./Otp.vue?vue&type=template&id=36a63d9e&ts=true"
import script from "./Otp.vue?vue&type=script&lang=ts"
export * from "./Otp.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__